import gql from 'graphql-tag';
import { BankFragment } from '../fragments/bank.fragment';
import { PageFragment } from '../fragments/page.fragment';

export const GET_BANKS = gql`
    query (
        $paging: CursorPaging
        $filter: BankFilter
        $sorting: [BankSort!]
    ) {
        banks (
            paging: $paging
            filter: $filter
            sorting: $sorting
        ) {
            pageInfo {
                ...Page
            }
            edges {
                node {
                    ...BankInfo
                }
            }
        }
    }
    ${BankFragment}
    ${PageFragment}
`;